export default class RiskSourceDto {
    /**
     * @type{number}
     */
    id;

    /**
     * @type{string}
     */
    name;

    /**
     * @type{Object<string, string>}
     */
    names;

    /**
     * @type{string[]}
     */
    manualLocales;

    constructor () {
        this.id = 0;
        this.name = '';
        this.names = {};
        this.manualLocales = [];
    }
}
